// extracted by mini-css-extract-plugin
module.exports = {"info":"Crossword_info__2oSWe","text":"Crossword_text__kvGYB","image":"Crossword_image__1UAkf","button":"Crossword_button__ZkHoz"};